import { DirectoryCategories } from "../modules";

export const DirectoryCategoriesPage = () => {
  return <DirectoryCategories />;
};
